// extracted by mini-css-extract-plugin
export default {"skeleton":"TableSkeletonRow_skeleton__IUbzj"};